<template>
  <aside class="pr-sidebar">
    <!-- <div class="pr-sidebar-brand">
      <img src="../assets/logo.svg" alt="Pagerunway" />
    </div> -->

    <nav class="pr-sidebar-nav">
      <div v-for="group in menuGroups" :key="group.label" class="pr-nav-group">
        <div class="pr-nav-group-label">{{ group.label }}</div>
        <ul>
          <li v-for="item in group.items" :key="item.name">
            <button
              class="pr-nav-item"
              :class="{ 'pr-nav-item--active': $route.name === item.name, 'pr-nav-item--flagship': item.flagship }"
              @click="go(item.path)"
            >
              <span class="material-symbols-outlined">{{ item.icon }}</span>
              <span class="pr-nav-item-label">{{ item.label }}</span>
              <!-- <span v-if="item.flagship" class="pr-nav-badge">ใหม่</span> -->
            </button>
          </li>
        </ul>
      </div>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      // ✅ ใหม่ — เอากลับมาแสดงใน sidebar ตามที่ขอ แต่โชว์เฉพาะร้านที่เปิดใช้งาน dine-in ไว้จริง —
      // ต้องดึงค่านี้เองเพราะ pageInfo หลัก (Vuex) ไม่มี field นี้รวมอยู่ (settings/dineIn เป็น
      // sub-collection แยกต่างหาก ดึงผ่าน endpoint เฉพาะ GET /dine-in/settings)
      dineInEnabled: false,
    };
  },
  computed: {
    pageId() {
      return this.$route.params.id;
    },
    menuGroups() {
      const id = this.pageId;
      const marketplaceItems = [
        { name: 'dashboard-order', label: 'ออเดอร์', icon: 'shopping_cart', path: `/dashboard/${id}/order`, flagship: true },
        { name: 'dashboard-customers', label: 'ลูกค้า', icon: 'group', path: `/dashboard/${id}/customers` }, // ✅ ใหม่
        { name: 'dashboard-stock', label: 'คลังสินค้า', icon: 'inventory_2', path: `/dashboard/${id}/stock`, flagship: true },
      ];
      // ✅ ใหม่ — โชว์เฉพาะร้านที่เปิดใช้งาน dine-in ไว้จริงเท่านั้น (เดิมย้ายไปไว้ในหน้าคลังสินค้าแทน
      // เพราะกลัวเมนูรก — ตอนนี้เอากลับมาแต่ซ่อนไว้ให้ร้านที่ไม่ได้ใช้ฟีเจอร์นี้ไม่ต้องเห็นเมนูเกินจำเป็น)
      if (this.dineInEnabled) {
        marketplaceItems.push({ name: 'dashboard-dine-in', label: 'สั่งหน้าร้าน', icon: 'table_restaurant', path: `/dashboard/${id}/dine-in` });
      }
      return [
        {
          label: 'ภาพรวม',
          items: [
            { name: 'dashboard-home', label: 'Console', icon: 'space_dashboard', path: `/dashboard/${id}/home` },
          ],
        },
        {
          label: 'มาร์เก็ตเพลส',
          items: marketplaceItems,
        },
        {
          label: 'AI Automation',
          items: [
            { name: 'dashboard-health', label: 'ตรวจสุขภาพเพจ', icon: 'health_metrics', path: `/dashboard/${id}/health` },
            { name: 'dashboard-chat', label: 'จัดการข้อความ', icon: 'quickreply', path: `/dashboard/${id}/chat` },
            { name: 'dashboard-comment', label: 'จัดการคอมเมนต์', icon: 'comment', path: `/dashboard/${id}/comment` },
            { name: 'dashboard-instagram-comments', label: 'Instagram Comments', icon: 'forum', path: `/dashboard/${id}/instagram-comments` },
            { name: 'dashboard-post', label: 'สร้างคอนเทนต์', icon: 'edit_note', path: `/dashboard/${id}/post` },
            { name: 'dashboard-ads', label: 'Ads Draft Builder', icon: 'campaign', path: `/dashboard/${id}/ads` },
          ],
        },
        {
          label: 'บัญชี',
          items: [
            { name: 'dashboard-package', label: 'แพ็กเกจ', icon: 'inventory', path: `/dashboard/${id}/package` },
            { name: 'dashboard-logs', label: 'ประวัติการใช้งาน', icon: 'schedule', path: `/dashboard/${id}/logs` },
            { name: 'dashboard-guide', label: 'คู่มือการใช้งาน', icon: 'menu_book', path: `/dashboard/${id}/guide` },
          ],
        },
      ];
    },
  },
  async mounted() {
    await this.loadDineInSettings();
  },
  watch: {
    // ✅ ใหม่ — sidebar เป็น component ที่ mount ค้างไว้ตลอด (ไม่ unmount ตอนสลับหน้าในแดชบอร์ดเดียวกัน)
    // แต่ pageId เปลี่ยนได้ถ้าผู้ใช้สลับไปจัดการอีกเพจหนึ่ง — ต้องโหลดค่าใหม่ทุกครั้งที่ pageId เปลี่ยน
    // ไม่งั้นเมนูจะค้างค่าของเพจเก่าไว้ผิดๆ
    pageId() {
      this.loadDineInSettings();
    },
  },
  methods: {
    async loadDineInSettings() {
      if (!this.pageId) return;
      try {
        const res = await this.$http.get(`${process.env.VUE_APP_BACKEND_URL}/api/pages/${this.pageId}/dine-in/settings`);
        this.dineInEnabled = !!res.data.settings?.enabled;
      } catch (err) {
        console.error('Sidebar loadDineInSettings error:', err);
        this.dineInEnabled = false; // เงียบไว้ — ผิดพลาดแค่ไม่โชว์เมนูนี้ ไม่ควรทำให้ sidebar ทั้งอันพัง
      }
    },
    go(path) {
      if (this.$route.path === path) return;
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.pr-sidebar {
  width: 100%;
  height: 100%;
  min-height: 100%;
  background: #fff;
  border-right: 1px solid var(--pr-border, #e8e8ee);
  padding: 20px 14px 24px;
  font-family: var(--pr-font-body, 'Noto Sans Thai', sans-serif);
}

.pr-sidebar-brand {
  padding: 6px 10px 20px;
}

.pr-sidebar-brand img {
  width: 120px;
}

.pr-nav-group {
  margin-bottom: 22px;
}

.pr-nav-group-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--pr-muted, #9090a0);
  padding: 0 10px 8px;
}

.pr-nav-group ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pr-nav-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  background: transparent;
  color: var(--pr-sub, #52525e);
  font-size: 0.88rem;
  font-weight: 500;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease, color 0.15s ease;
}

.pr-nav-item .material-symbols-outlined {
  font-size: 20px;
  color: var(--pr-muted, #9090a0);
  transition: color 0.15s ease;
}

.pr-nav-item:hover {
  background: var(--pr-bg-soft, #f8f8fc);
  color: var(--pr-text, #1a1a24);
}

.pr-nav-item--active {
  background: linear-gradient(135deg, rgba(13, 13, 18, 0.10), rgba(37, 99, 235, 0.10));
  color: var(--pr-indigo, #6366f1);
  font-weight: 700;
}

.pr-nav-item--active .material-symbols-outlined {
  color: var(--pr-indigo, #6366f1);
}

.pr-nav-item-label {
  flex: 1;
}

.pr-nav-badge {
  font-size: 0.62rem;
  font-weight: 700;
  color: #fff;
  background: var(--pr-grad, linear-gradient(135deg, #6366f1, #2563eb));
  border-radius: 999px;
  padding: 2px 7px;
}
</style>
